import { toast } from "react-toastify";
import { BASE_URL } from "../../config";

const getAuthToken = () => localStorage.getItem("authToken");
const getCompanyId = () => localStorage.getItem("userId"); // ✅ always latest

export const updateOrderData = async (updatedItem, actionType = "add") => {
  try {
    let url, method, body;

    if (actionType === "add") {
      url = `${BASE_URL}api/order/add`;
      method = "POST";
      body = JSON.stringify(updatedItem);
    } else if (actionType === "update") {
      url = `${BASE_URL}api/order/update`;
      method = "PUT";
      body = JSON.stringify(updatedItem);
    } else if (actionType === "delete") {
      const confirmDelete = window.confirm("Are you sure you want to delete this order?");
      if (!confirmDelete) {
        toast.info("Order deletion cancelled.");
        return;
      }

      url = `${BASE_URL}api/order/delete/${updatedItem.orderId}`;
      method = "DELETE";
      body = null;
    } else {
      throw new Error("Invalid action type provided.");
    }

    const token = getAuthToken();

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body,
    });

    if (!response.ok) {
      throw new Error(`Failed to ${actionType} order. Status: ${response.status}`);
    }

    const data = await response.json(); // ✅ Parse JSON here

    let successMessage = "Order saved successfully!";
    if (actionType === "update") successMessage = "Order updated successfully!";
    if (actionType === "delete") successMessage = "Order deleted successfully!";

    toast.success(successMessage);
    return data; // ✅ Now you'll get { httpStatusCode, status, body, ... }

  } catch (error) {
    console.error(`Error ${actionType}ing order:`, error);
    toast.error(`Error ${actionType}ing order: ${error.message}`);
  }
};


export const fetchAllCustomerData = async () => {
  try {
    const token = getAuthToken();
    const companyId = getCompanyId(); 

    const response = await fetch(
      `${BASE_URL}api/order/getById/${companyId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch orders");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching customer data:", error);
    toast.error(`Error fetching customer data: ${error.message}`);
    return [];
  }
};
